import React, { useState } from "react";
import { Form, Input, Button, Card, message } from "antd";
import { BellOutlined, SendOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./notification.css";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";

const { TextArea } = Input;

const SendNotification = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleFinish = (values) => {
    let getRes = (res) => {
      if (res.status === 200) {
        message.success("Notification sent successfully.");
        navigate("/");
      } else {
        message.error(res.message || "Failed to send notification.");
      }
    };

    let body = {
      title: values.title,
      content: values.body,
    };

    callApi(
      "POST",
      routes.sendNotification,
      body,
      setLoading,
      getRes,
      (error) => console.log("error", error)
    );
  };

  return (
    <div className="notification-page-container">
      {/* Loader component remains as you had it */}

      <Card
        className="notification-card"
        title={
          <div className="notification-card-title">
            <BellOutlined />
            <span>Notify All Users</span>
          </div>
        }
      >
        <Form layout="vertical" onFinish={handleFinish}>
          <Form.Item
            label="Notification Title"
            name="title"
            rules={[{ required: true, message: "Please enter a title" }]}
          >
            <Input
              placeholder="e.g. New Update Available"
              size="large"
              className="custom-input"
            />
          </Form.Item>

          <Form.Item
            label="Message Details"
            name="body"
            rules={[
              { required: true, message: "Please enter notification details" },
            ]}
          >
            <TextArea
              placeholder="Type the message you want to send to all registered users..."
              autoSize={{ minRows: 6 }}
              size="large"
              className="custom-textarea"
            />
          </Form.Item>

          <Form.Item>
            <Button
              loading={loading}
              type="primary"
              htmlType="submit"
              size="large"
              block
              icon={<SendOutlined />}
              className="notification-submit-btn"
            >
              Send Notification Now
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default SendNotification;
